import cookies from "./cookies";
const userIdCookies = cookies.guid();

export const prepareData = ( event,audio,audioInfos) => {
  const isMobile = window.matchMedia("(pointer:coarse)").matches;
  const currentT = Math.trunc(audio.getCurrentTime());
  const xApp = isMobile ? "podcast_mobile" : "podcast_internet";
  const data = {
    type: audioInfos?.stats_res?.["x-app"] || xApp,
    "x-event": event,
    timecode: currentT,
    currentTime: currentT,
    "c-proto": location.protocol,
    client: audioInfos?.stats_res?.client ,
    user_id: (cookies.cookiesUserId() +
      "" +
      audioInfos.stats_res?.["c-ip"]) ,
    "v-id":
      userIdCookies +
      audioInfos.stats_res?.["c-ip"] +
      audioInfos?.stats_res?.["x-app"],
    new_user: "y",
    "c-referrer": document.referrer ? document.referrer : location.href,
    "c-user-agent": window.navigator.userAgent,
    "x-app": audioInfos?.stats_res?.["x-app"] || (xApp),
    v: audioInfos?.stats_res?.v,
    "c-ip": audioInfos?.stats_res?.["c-ip"],
    "s-port": audioInfos.stats_res?.["s-port"],
    "s-ip": audioInfos.stats_res?.["s-ip"],
    "x-duration": audioInfos?.watchedDuration || (0),
    autoplay: audioInfos?.autoplay,
    seekCount: audioInfos.seekCount,
    pauseCount: audioInfos.pauseCount,
    watchedDuration: audioInfos.watchedDuration || (0),
    stats_url: audioInfos?.stats_res?.stats_url,
    channels: ((audioInfos?.stats_res?.channels?.[0] || "") + ""),
    themes: ((audioInfos?.stats_res?.themes?.[0] || "") + ""),
    groups: ((audioInfos?.stats_res?.groups?.[0] || "") + ""),
    x_file_name: audioInfos.audioTitle 
  };
  if (Math.round(audio.getDuration()) > 0) {
    data.duration = Math.trunc(audio.getDuration());
  }
  const searchParams = new URLSearchParams(window.location.search);

  for (const [key, value] of searchParams) {
    data[key] = value;
  }

  return data;
};

export const service = async (data) => {
  if (data.client) {
    return await fetch(
      data.stats_url
        ? data.stats_url
        : `https://service-stats.webtv-solution.com/webtv/logs/save`,
      {
        body: JSON.stringify(data),
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
  }
  return null;
};
